export const migrationContext = 'branchMigration';

export const migrationKeys = {
  goToMigrationButton: `${migrationContext}-mbMigrationIWantToMigrateToTheNewBankButton`,
  headerStartText: `${migrationContext}-mbMigrationHeaderStartYourMigrationProcess`,
  headerExitButton: `${migrationContext}-mbMigrationExitButton`,
  migrationPhone: `${migrationContext}-mbMigrationPhoneLink`,
};
